import { ref, computed, watch } from 'vue'
import store from '@/store'
import { FUNCTION_TYPE } from '@/constants'

// item_type 定義
export const ITEM_TYPE = {
  STATUS: 'status',
  INDOOR: 'indoor',
  PLACE: 'place',
  BATTERY: 'battery',
  ACTIVITY: 'activity',
  SENSOR_DATA: 'sensor_data',
  ATTRIBUTE: 'attribute',
  POSITIONING: 'last_positioning_at',
  ACCURACY: 'accuracy',
  ACCURACY_RATING: 'accuracy_rating',
  REGISTRATION: 'create_at',
  DEVICE: 'device',
  SENSOR_NAMES: 'sensor_names',
}

// アイテムと権限の対応
const ITEM_TYPE_AVAILABLE_FUNCTION_TYPE = {
  [ITEM_TYPE.STATUS]: FUNCTION_TYPE.STATUS,
  [ITEM_TYPE.INDOOR]: FUNCTION_TYPE.INDOOR,
  [ITEM_TYPE.PLACE]: FUNCTION_TYPE.PLACE,
  [ITEM_TYPE.BATTERY]: FUNCTION_TYPE.COMMON,
  [ITEM_TYPE.ACTIVITY]: FUNCTION_TYPE.COMMON,
  [ITEM_TYPE.SENSOR_DATA]: FUNCTION_TYPE.SENSOR,
  [ITEM_TYPE.ATTRIBUTE]: FUNCTION_TYPE.USER,
  [ITEM_TYPE.POSITIONING]: FUNCTION_TYPE.GPS,
  [ITEM_TYPE.ACCURACY]: FUNCTION_TYPE.GPS,
  [ITEM_TYPE.ACCURACY_RATING]: FUNCTION_TYPE.GPS,
  [ITEM_TYPE.REGISTRATION]: FUNCTION_TYPE.COMMON,
  // device / sensor_names は機能権限に関係なく表示する仕様のため COMMON を割り当てる
  [ITEM_TYPE.DEVICE]: FUNCTION_TYPE.COMMON,
  [ITEM_TYPE.SENSOR_NAMES]: FUNCTION_TYPE.COMMON,
}

/**
 * ユーザーリストの表示項目を保持・管理
 */
export function useUserStatusAdditionalItems() {
  /**
   * 簡易表示フラグ
   * @type {Ref.<boolean>}
   */
  const isSimple = ref(false)
  /**
   * 現在の非表示アイテム
   * @type {Ref.<string[]>}
   */
  const excludedItems = ref([])

  /**
   * 選択可能表示アイテム
   * @type {ComputedRef.<string[]>}
   */
  const selectableItems = computed(() => {
    const itemValue =
      store.getters['systemSetting/getItemValueByItemKey']('user_disp_item')
    return (itemValue?.split('|') || []).filter((item) => {
      const itemType = item.split(':')[0]
      return !!store.getters['functionType'](
        ITEM_TYPE_AVAILABLE_FUNCTION_TYPE[itemType]
      )
    })
  })
  /**
   * 選択表示アイテム
   * @type {ComputedRef.<string[]>}
   */
  const items = computed({
    get: () =>
      selectableItems.value.filter(
        (item) => !excludedItems.value.includes(item)
      ),
    set: (value) => {
      excludedItems.value = selectableItems.value.filter(
        (item) => !value.includes(item)
      )
    },
  })

  // 変更を store に反映
  watch(excludedItems, (value) => {
    store.commit('member/setExcludedItems', value)
  })
  watch(isSimple, (value) => {
    store.commit('member/setIsSimple', value)
  })

  /**
   * 初期値設定
   */
  // store の状態反映
  isSimple.value = store.getters['member/isSimple']
  excludedItems.value = store.getters['member/excludedItems']

  return {
    isSimple,
    items,
    selectableItems,
  }
}
